export class SubscribeToTextNotifications {
    public Header: string | undefined
    public IsDisplay: boolean | undefined
    public Options: Option | undefined
}

export class Option {
    public Sequence: number | undefined
    public Text: string | undefined
    public Value: boolean | undefined
    public IsSelected: boolean | undefined
}